import React, { useContext, useState } from 'react';
import { DataGridGroup, useResponsiveParams, Text } from 'quanta-ui';
import {
  faCheck,
  faChevronCircleDown,
  faChevronCircleUp,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useQuery } from '@apollo/client';
import {
  GET_BUY_HEALTH_POLICY_VAR_DETAILS,
  GET_GENDER_LIST,
} from '../../queries';
// import Loading from '../../../../../../lib/layout/loading';
// import Error from '../../../../../../lib/layout/error';
// import CurrencyFormater from '../../../../../../lib/intl/CurrencyFormater';
// import ModalViewBreakupHealth from '../../../../../common/view-breakup/health/view-breakup';
import { Loading,Error } from 'quanta-flows/modules/layout';
import { CurrencyFormater } from 'quanta-flows';
import ModalViewBreakupHealth from '../../summary-panel/modal-view-breakup';
// import {ModalViewBreakupHealth} from 'quanta-flows/modules/common/viewBreakUp';

export default function InsuranceData({
  lobCode,
  lobName,
  productName,
  productCode,
  planName,
  planCode,
  proposalNumber,
}) {
  const [expanded, setExpanded] = useState(false);
  const [showViewBreakup, setShowViewBreakup] = useState(false);

  const {
    loading: buyHealthPolicyLoading,
    error: errorBuyHealthPolicy,
    data: dataBuyHealthPolicy,
  } = useQuery(GET_BUY_HEALTH_POLICY_VAR_DETAILS);
  const {
    loading: loadingGenderList,
    error: errorGenderList,
    data: dataGenderList,
  } = useQuery(GET_GENDER_LIST);


  if (dataBuyHealthPolicy) {
    var buyHealthPolicy = dataBuyHealthPolicy?.buyHealthPolicy;
    var quoteData = buyHealthPolicy?.quoteData;
    var planData = buyHealthPolicy?.planData;
    var plans = planData?.plans;
  }
  if (dataGenderList) {
    var { genderList } = dataGenderList;
  }

  const repeat = useResponsiveParams({
    for_mobile: 1,
    for_desktop: 4,
  });
  let grid_data = [
    {
      colSpan: 4,
      className: '-mb-8',
      grid_data: [
        {
          label: (
            <span className="text-primary font-bold">Plan Name</span>
          ),
          text: <Text>{planName}</Text>,
        },
        {
          label: (
            <span className="text-primary font-bold">
              Sum Insured
            </span>
          ),
          text: <Text>{CurrencyFormater(quoteData?.cover?.sum_insured)}</Text>,
        },
        {
          label: (
            <span className="text-primary font-bold">
              Customer Location
            </span>
          ),
          text: (
            <Text>
              {[
                // quoteData?.location?.zone?.trim(),
                quoteData?.location?.city?.trim(),
                quoteData?.location?.pincode?.trim(),
              ]
                .filter((a) => a)
                .join(', ')}
            </Text>
          ),
        },
        {
          label: (
            <span className="text-primary font-bold">
              Annual Premium (inclusive of all taxes)
            </span>
          ),
          text: (
            <div className="flex justify-start space-x-2 mt-1">
              <Text type="larger" severity="info" className="-mt-1">
                {CurrencyFormater(
                  plans?.find((p) => p.name === planName)?.premium
                    ?.totalPremium,
                )}
              </Text>
              <span className="mt-1.5">
                <Text
                  severity="action"
                  type="label"
                  className="quanta_link md:mt-1 md:ml-2 cursor-pointer"
                  onClick={(e) => {
                    setShowViewBreakup(true);
                  }}
                >
                  View Breakup
                </Text>
              </span>
            </div>
          ),
        },
      ],
    },
    {
      title: (
        <div
          className="text-secondary text-base cursor-pointer -mb-3"
          onClick={(_) => setExpanded(!expanded)}
        >
          Show details
          <FontAwesomeIcon
            icon={expanded ? faChevronCircleUp : faChevronCircleDown}
            className="text-secondary ml-2 cursor-pointer"
          />
        </div>
      ),
      titleType: 'normal',
      repeat: 4,
      grid_data: expanded
        ? [
            {
              label: (
                <Text type="label" className="font-bold">
                  Member
                </Text>
              ),
              text: buyHealthPolicy.insuredDetails
                .map((insured) => insured.relationship)
                .join(','),
              colSpan: 1,
            },
            {
              label: (
                <Text type="label" className="font-bold">
                  Cover type
                </Text>
              ),
              text: quoteData.cover.type,
              colSpan: 1,
            },
            {
              label: (
                <Text type="label" className="font-bold">
                  Tenure
                </Text>
              ),
              text: quoteData.cover.tenure,
              colSpan: 1,
            },
          ]
        : [],
    },
    expanded
      ? {
          title: 'Base Covers',
          titleType: 'normal',
          repeat: 4,
          className: 'pt-0 pb-2',
          gridClassName: 'space-y-2',
          grid_data:
            plans &&
            plans
              .find((p) => p.name === planName)
              .covers.map((c) => {
                return {
                  text: (
                    <div className="flex flex-row space-x-1 ">
                      <div className="text-success">
                        <FontAwesomeIcon icon={faCheck} />
                      </div>
                      <div>{c.name}</div>
                    </div>
                  ),
                };
              }),
        }
      : null,
    ...(expanded
      ? plans &&
        plans
          .find((p) => p.name === planName)
          .packs.map((pack) => {
            if (
              pack.addOnCovers.filter((add) => add.selected).length >
              0
            ) {
              return {
                title: pack.name,
                titleType: 'normal',
                className: 'pt-0 pb-4',
                gridClassName: 'space-y-2',
                repeat: 4,
                grid_data:
                  pack &&
                  pack.addOnCovers
                    .filter((add) => add.selected)
                    .map((add, idx) => {
                      return {
                        text: (
                          <div
                            key={idx}
                            className="flex flex-row space-x-1"
                          >
                            <div className="text-success">
                              <FontAwesomeIcon icon={faCheck} />
                            </div>
                            <div>{add.name}</div>
                          </div>
                        ),
                      };
                    }),
              };
            }
            return null;
          })
          .filter((pack) => pack)
      : []),
  ].filter((d) => d);

  return buyHealthPolicyLoading || loadingGenderList ? (
    <div className="flex items-center justify-center">
      <Loading customMessage="Loading Plan Details" />
    </div>
  ) : errorBuyHealthPolicy || errorGenderList ? (
    <div className="flex items-center justify-center">
      <Error
        error={{
          message: `There was an issue fetching the Plan and Cover Details. Please try again after some time...`,
        }}
      />
    </div>
  ) : (
    <div>
      <DataGridGroup
        data={grid_data}
        repeat={repeat}
        textType="label"
        titleType="title"
        titleSeverity="info"
        // className="w-full"
        gap={0.5}
        isSeparatorRequired={false}
        gapY={0.5}
        spaceY={2}
        gapX={0.5}
        nullData={() => (
          <Text className="opacity-40">Not Captured</Text>
        )}
      />
      <ModalViewBreakupHealth
        {...{
          showViewBreakup,
          setShowViewBreakup,
          selectedPlanTypeView: planName,
          productName,
          genderList,
          quoteData,
          planData,
          title: 'Premium Breakup for Quote',
        }}
      />
    </div>
  );
}
